export default __webpack_public_path__ + "static/media/DisconnectIcon.d8c2b41c.svg";